import React, { useState, useEffect } from 'react';
import Helmet from "react-helmet";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './global';
import { theme } from './theme';

//import { Burger, Menu } from './components';

import Burger from "./components/Burger"
import Menu from "./components/Menu"
import MainTile from "./components/MainTile"
import Intro from "./components/Intro"
import FeaturedTile from "./components/FeaturedTile"
import Video from "./components/Video"
import Clients from "./components/Clients"
import Awards from "./components/Awards"
import Recommendations from "./components/Recommendations"
import Website from "./components/Websites"
import Services from "./components/Services"
import Numbers from "./components/Numbers"

import Knowledge from "./components/Knowledge"

import NotFound from "./components/NotFound"

//import Breakpoints from '@/components/Breakpoints';

import { websites } from './components/Websites/data';

import { FaUser, FaUserFriends, FaLink} from 'react-icons/fa';

import './app.scss';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-67062059-1');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  const [open, setOpen] = useState(false);

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth
  })
  useEffect(() => {
    function handleResize() {
      setDimensions({
        width: window.innerWidth
      })
    }
    window.addEventListener('resize', handleResize)

    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Router>
    <ThemeProvider theme={theme}>
    <>
      
      <Helmet>
        {/* <!-- HTML Meta Tags --> */}
        <title>Sean Palmer - Freelance Digital Specialist</title>
        <meta name="description" content="Freelance website digital specialist fueled by UX based in Sussex with 14+ years of experience." />

        {/* <!-- Google / Search Engine Tags --> */}
        <meta itemprop="name" content="Sean Palmer - Freelance Digital Specialist" />
        <meta itemprop="description" content="Freelance website digital specialist fueled by UX based in Sussex with 14+ years of experience." />
        <meta itemprop="image" content="https://www.seanp.co.uk/images/intro1.png" />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:url" content="https://www.seanp.co.uk" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Sean Palmer - Freelance Digital Specialist" />
        <meta property="og:description" content="Freelance website digital specialist fueled by UX based in Sussex with 14+ years of experience." />
        <meta property="og:image" content="https://www.seanp.co.uk/images/intro1.png" />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sean Palmer - Freelance Digital Specialist" />
        <meta name="twitter:description" content="Freelance website digital specialist fueled by UX based in Sussex with 14+ years of experience." />
        <meta name="twitter:image" content="https://www.seanp.co.uk/images/intro1.png" />
      </Helmet>
      <GlobalStyles />
      <header className="header">
        <div className="logo">
          <a href="/">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1233 245.715">
          <title>Sean Palmer - Digital Specialist</title>
          <g id="Group_1" data-name="Group 1" transform="translate(-373 -604.286)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="1233" height="245" transform="translate(373 605)" fill="none"/>
            <path id="Path_3" fill="#fff" data-name="Path 3" d="M77.161-11.653a11.467,11.467,0,0,1-3.2,8.4A11.19,11.19,0,0,1,65.613,0H24.25A11.544,11.544,0,0,1,15.8-3.254a11.269,11.269,0,0,1-3.307-8.4V-53.33H27.085v40.417H62.568V-52.07l-45.352-54.8a19.072,19.072,0,0,1-4.724-12.493v-33.279a11.269,11.269,0,0,1,3.307-8.4,11.544,11.544,0,0,1,8.451-3.254H65.613a11.19,11.19,0,0,1,8.346,3.254,11.467,11.467,0,0,1,3.2,8.4v38.213H62.568v-36.953H27.085v34.644l45.562,54.8a18.774,18.774,0,0,1,4.514,12.283ZM163.181,0h-53.96V-164.294h53.33v12.913H123.813v61.309h35.273v13.123H123.813v64.038h39.368Zm95.258,0H243.952l-5.774-36.533H205.529L199.755,0H185.688V-.42l29.29-164.294H229.36ZM236.288-49.446l-14.382-89.023L207.419-49.446ZM352.123,0H342.045L298.163-120.833V0H284.411V-164.294h10.918L338.371-45.562V-164.294h13.752Zm145.9-76.951a11.444,11.444,0,0,1-3.307,8.451,11.444,11.444,0,0,1-8.451,3.307H447.528V0H432.935V-164.294h53.33a11.544,11.544,0,0,1,8.451,3.254,11.269,11.269,0,0,1,3.307,8.4Zm-14.592-1.26v-73.171h-35.9V-78.21ZM593.6,0H579.109l-5.774-36.533H540.686L534.912,0H520.845V-.42l29.29-164.294h14.382ZM571.446-49.446l-14.382-89.023L542.576-49.446ZM672.058,0h-52.49V-164.294H634.16V-12.913h37.9ZM779.494,0H765.742V-104.036q0-2.2,1.47-12.913L740.337-15.432H737.4L710.522-116.948q1.47,10.813,1.47,12.913V0H698.239V-164.294h13.542l26.665,106.87a37.5,37.5,0,0,1,.42,4.724,39.21,39.21,0,0,1,.42-4.724l26.665-106.87h13.542Zm86.44,0h-53.96V-164.294H865.3v12.913H826.567v61.309H861.84v13.123H826.567v64.038h39.368Zm98.933,0H949.54L918.991-87.974l1.995-2.939H947.02v-60.469H909.542V0H894.95V-164.294h55.01a11.366,11.366,0,0,1,8.4,3.254,11.366,11.366,0,0,1,3.254,8.4v62.358q0,11.863-15.957,11.863-1.575,0-4.619-.157t-4.409-.157Q950.8-39.473,964.867,0Z" transform="translate(641 769)" />
            <path id="Path_4" fill="#fff" data-name="Path 4" d="M26.13-9.6A9.229,9.229,0,0,1,23.365-2.7,9.581,9.581,0,0,1,16.391,0H4.242V-53.109H16.391a9.566,9.566,0,0,1,6.991,2.7,9.259,9.259,0,0,1,2.749,6.906Zm-4.717-.475V-43.1a5.649,5.649,0,0,0-1.646-4.225,5.829,5.829,0,0,0-4.259-1.612H8.959V-4.174h6.278A6.328,6.328,0,0,0,19.7-5.752,5.59,5.59,0,0,0,21.413-10.079ZM65.184,0H60.467V-53.109h4.717Zm56.123-3.767a3.674,3.674,0,0,1-1.052,2.715A3.674,3.674,0,0,1,117.54,0H103.592a3.674,3.674,0,0,1-2.715-1.052,3.674,3.674,0,0,1-1.052-2.715V-49.342a3.674,3.674,0,0,1,1.052-2.715,3.674,3.674,0,0,1,2.715-1.052H117.54a3.674,3.674,0,0,1,2.715,1.052,3.674,3.674,0,0,1,1.052,2.715V-36.99h-4.751V-48.935H104.542V-4.174h12.013V-22.533h-5.667v-4.072h10.418ZM160.5,0h-4.717V-53.109H160.5Zm52.933-48.935h-8.212V0H200.5V-48.935h-8.28v-4.174h21.21ZM266.158,0h-4.683l-1.866-11.81H249.054L247.188,0h-4.547V-.136l9.468-53.109h4.649ZM259-15.984l-4.649-28.777-4.683,28.777ZM315.29,0H298.322V-53.109h4.717V-4.174H315.29Zm92.326-3.767a3.707,3.707,0,0,1-1.035,2.715A3.617,3.617,0,0,1,403.883,0H390.512a3.732,3.732,0,0,1-2.732-1.052,3.643,3.643,0,0,1-1.069-2.715V-17.239h4.717V-4.174H402.9V-16.832l-14.66-17.714a6.165,6.165,0,0,1-1.527-4.038V-49.342a3.643,3.643,0,0,1,1.069-2.715,3.732,3.732,0,0,1,2.732-1.052h13.371a3.617,3.617,0,0,1,2.7,1.052,3.707,3.707,0,0,1,1.035,2.715V-36.99H402.9V-48.935h-11.47v11.2l14.728,17.714a6.069,6.069,0,0,1,1.459,3.97Zm55.173-21.108a3.7,3.7,0,0,1-1.069,2.732,3.7,3.7,0,0,1-2.732,1.069H446.465V0h-4.717V-53.109h17.239a3.732,3.732,0,0,1,2.732,1.052,3.643,3.643,0,0,1,1.069,2.715Zm-4.717-.407V-48.935H446.465v23.653ZM513.481,0H496.039V-53.109h17.239v4.174H500.756v19.818h11.4v4.242h-11.4v20.7h12.726Zm54.426-3.767a3.613,3.613,0,0,1-1.086,2.715A3.79,3.79,0,0,1,564.073,0H550.4a3.674,3.674,0,0,1-2.715-1.052,3.674,3.674,0,0,1-1.052-2.715V-49.342a3.674,3.674,0,0,1,1.052-2.715,3.674,3.674,0,0,1,2.715-1.052h13.676a3.79,3.79,0,0,1,2.749,1.052,3.613,3.613,0,0,1,1.086,2.715V-36.99h-4.751V-48.935h-11.81V-4.174h11.81V-17.239h4.751ZM606.927,0H602.21V-53.109h4.717Zm56.055,0H658.3l-1.866-11.81H645.878L644.012,0h-4.547V-.136l9.468-53.109h4.649Zm-7.16-15.984-4.649-28.777-4.683,28.777ZM712.114,0H695.146V-53.109h4.717V-4.174h12.251Zm37.221,0h-4.717V-53.109h4.717Zm55.342-3.767a3.707,3.707,0,0,1-1.035,2.715A3.617,3.617,0,0,1,800.944,0H787.574a3.732,3.732,0,0,1-2.732-1.052,3.643,3.643,0,0,1-1.069-2.715V-17.239h4.717V-4.174h11.47V-16.832L785.3-34.546a6.165,6.165,0,0,1-1.527-4.038V-49.342a3.643,3.643,0,0,1,1.069-2.715,3.732,3.732,0,0,1,2.732-1.052h13.371a3.617,3.617,0,0,1,2.7,1.052,3.707,3.707,0,0,1,1.035,2.715V-36.99H799.96V-48.935H788.49v11.2l14.728,17.714a6.069,6.069,0,0,1,1.459,3.97ZM857.1-48.935h-8.212V0h-4.717V-48.935h-8.28v-4.174H857.1Z" transform="translate(649 850)" />
            <path id="Union_1" data-name="Union 1" d="M245,245H0V0H245V245h0ZM64.5,229.364l28.422-27.014v-10.8h50.732l32.32-32.186V64.3H92.922l12.524-11.662h81.115L215.3,24.5H92.922L64.5,52.633V95.08h79.154v11.413H64.5Zm29.511-70.043V138.735h49.035v10.938l-9.607,9.648Z" transform="translate(373 605)" fill="#fc6100"/>
          </g>
        </svg>
        </a>
        </div>
        <Burger open={open} setOpen={setOpen} />
      </header>
      <Menu open={open} setOpen={setOpen} />
      <Switch>
          <Route exact path="/knowledge">
            <Knowledge />
          </Route>
          <Route exact path="/websites">
            <Website />
          </Route>
          <Route exact path="/">
          <MainTile 
          image="images/intro1.png"
            />
          <section className="intro section--padding">
            <div className="angle-top" style={{borderRightColor: '#eee', borderRightWidth: dimensions.width}}></div>
            <div className="container container--flex">
                <div className="intro__content">
                    <header className="section-header">
                        <h1 className="section-title">About me.</h1>
                    </header>
                    <p>
                    I’m a highly motivated, hard working individual with the ability to work well within a team. I’m ambitious and highly-creative, with a keen eye for detail. I enjoy enhancing my skills and keeping up-to-date with the latest technologies. I produce new ideas and have the ability to multi task projects. With 11 years of working with colleagues and clients I have great communication skills, discussing and solving problems. Outstanding ability of using all types of IT software and hardware.
                    </p>
                    <ul className="bullet-list">
                      <li>11 Years building with HTML, CSS and JavaScript (inc JQuery)</li>
                      <li>10 Years working in agencies</li>
                      <li>6 Years building Kentico and WordPress</li>
                      <li>12 Years using Adobe Creative Suite</li>
                      <li>8 Years experience with SEO, SNI, GA, GTM, GSC</li>
                      <li>6 Months experience with React and UX</li>
                    </ul>
              </div>
              <div className="intro__image">
                <img src="images/sean1.jpg" />
                </div>
              </div>
              <div className="angle-bottom" style={{borderLeftColor: '#eee', borderLeftWidth: dimensions.width}}></div>
          </section>
          <Numbers websites={websites.length} dimensions={dimensions} />
          <Clients dimensions={dimensions} />
          <div className="background--skew-left">
          <section className="section latest--home section--padding">
              <div className="container container--flex">
                <header className="section-header">
                    <h2 className="section-title">Featured work</h2>
                    <p>Here is a list of some of my favourite work, to see all projects I have worked on please click the below link</p>
                    <Link to='/websites' className="btn button button--orange">See all work</Link>
                </header>
              </div>
              <div className="container container--full">
          <div className="grid grid--websites">
              {websites.filter(website => website.home === true).map((website, websiteIndex) => {

                  return (
                      <div className={`card card--website card--large`} key={websiteIndex}>
                          {(website.video ?
                              (<video autoPlay loop muted className="hero__video" poster="">
                                  <source src={`videos/${website.codename}.webm`} type="video/webm" />
                                  <source src={`videos/${website.codename}.mp4`} type="video/mp4" />
                              </video>)
                              :
                              (<img src={`/images/websites/${website.codename}.jpg`} className={website.screenshot} alt={website.name} />)
                          )}
                          <div className="website__content">
                              <span className="website__name">{website.name}</span>
                              <span className="website__summary">{website.summary}</span>
                              <span className="card__arrow"></span>
                          </div>
                          {(website.teambuild ?
                              (<span className="website__tag"><FaUserFriends /></span>)
                              :
                              (<span className="website__tag"><FaUser /></span>)
                          )}
                          {(website.url ?
                              (<a href={website.url} className="website__tag website__url"><FaLink /></a>)
                              :
                              (null)
                          )}
                      </div>
                  )
              })}
          </div>
          </div>
          </section>
          <Recommendations />
          </div>
          <Awards />
          <footer className="footer">
            &copy; Copyright Sean Palmer 2020
          </footer>
              </Route>
              <Route component={NotFound} />
          </Switch>
          
        </>
        </ThemeProvider>
    </Router>
    
  );
}

export default App;
